import type { RangeRenderState } from 'instantsearch.js/es/connectors/range/connectRange';
import { getAmount } from '../../../../../utils/currencyHelper';

export function getPriceRangeValue(
  start: RangeRenderState['start'],
  range: RangeRenderState['range'],
  currencySymbol: string,
) {
  const minPrice = parseInt(getAmount(start[0] === -Infinity ? range.min : start[0]).toString(), 10);
  const maxPrice = parseInt(getAmount(start[1] === Infinity ? range.max : start[1]).toString(), 10);
  return `${currencySymbol}${minPrice} - ${currencySymbol}${maxPrice}`;
}
